<!--  -->
<template>
  <div class="child-box" style="height:auto">
    <div class="child-head">
      <div class="child-name">风险展示</div>
    </div>
    <div class="content">
      <div class="content-item" v-for="(item,i) in baseData" :key="i">
          <div class="text">{{item.content}}</div>
          <div class="name">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      baseData: [
        {
          name: "K1-K6",
          content: "3"
        },
        {
          name: "K6-K7",
          content: "1"
        },
        {
          name: "K7-K10",
          content: "0"
        }
      ]
    };
  },

  components: {},

  computed: {},

  methods: {}
};
</script>
<style lang="less" scoped>
.content {
  width: 92%;
  margin-left: 4%;
  display: flex;
  margin-top: 5%;
  margin-bottom: 18px;
  .content-item {
    background: url(../assets/risk-item.png);
    width: 75px;
    height: 75px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-left: 23px;
    color: #bcdeff;
    .name {
      font-size: 10px;
      text-align: center;
      margin-top: 2px;
    }
    .text {
      font-size: 19px;
      text-align: center;
      margin-top: 12px;
    }
  }
}
</style>